<template lang="pug">
transition(name='slideup')
  .save-container(v-if='$store.state.unsavedChanges || loading')
    b(v-if='valid') {{ confirmText }}
    b(v-else) Niet alle velden zijn juist ingevoerd
    v-btn(color='primary', @click='save', :loading='loading', v-if='valid')
      v-icon.mr-2 fa fa-check
      | Opslaan
</template>

<script>
export default {
  data () {
    return {
      loading: false,
      confirmText: null,
      valid: true,
      saveFunc: null,
      cancelFunc: null
    }
  },

  methods: {
    show (saveFunc, cancelFunc, confirmText) {
      // this.reset() // TODO
      this.valid = true

      this.$root.$snackbar.hide()

      this.$store.commit('setUnsavedChanges', true)

      this.saveFunc = saveFunc
      this.cancelFunc = cancelFunc

      if (confirmText) this.confirmText = confirmText
    },

    hide () {
      this.$store.commit('setUnsavedChanges', false)
    },

    setValid (v) {
      this.valid = v
    },

    async save () {
      this.loading = true

      this.$store.commit('setUnsavedChanges', false) // Must be before saveFunc() because saveFunc can trigger a route change

      if (this.saveFunc) await this.saveFunc()

      this.loading = false
    },

    cancel () {
      if (this.cancelFunc) this.cancelFunc()
    },

    reset () {
      this.valid = true
      this.confirmText = 'Wil je de aangebrachte wijzigingen opslaan?'
      this.saveFunc = null
      this.cancelFunc = null
    }
  },

  created () {
    this.reset()
  },

  watch: {
    '$store.state.unsavedChanges': function (v) {
      if (v) {
        window.onbeforeunload = () => true
      } else {
        window.onbeforeunload = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.save-container {
  background: $dark;
  height: 100px;
  width: 100vw;
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: $g;
  z-index: 10;

  b {
    color: white;
  }

  .v-btn {
    margin-left: $g;
    box-shadow: none !important;
  }
}
</style>
